"use client"


import { TextReveal } from "./TextReveal";
import clsx from "clsx"


function ManifestText(){

  

    return(
        <div id="solution" className="pt-10 lg:pt-20 text-[#042040]">
             <div className="w-fit md:px-0 mx-auto">
              <div className="max-w-[980px] mx-2 md:mx-10 bg-[#FAFAFA] rounded-[50px] p-5 md:p-10 border border-4 border-[#042040] hover:border-[#FED90F] shadow-[10px_10px_0px_#FED90F] hover:shadow-none ease-in duration-500 ">             
                <h2 className="text-3xl md:text-5xl lg:text-6xl text-center font-bold mx-auto max-w-[1000px] px-10 leading-10 md:leading-[4rem] lg:leading-[5rem] mb-0 lg:mb-20">Nous rendons 
                <p className="relative inline-block">
                  <span className="bg-[#FED90F] w-[83px] md:w-[130px] lg:w-[165px] h-10 md:h-16 lg:h-20 absolute top-0 left-2.5 md:left-4 lg:left-5 z-1 rounded-lg transform rotate-[-2deg]"></span>
                  <span className="relative">&nbsp;&nbsp;enfin&nbsp;&nbsp;</span>
                </p> 
                
                accessible l&apos;expertise financière pour les entrepreneurs.</h2>


                <div className="mt-5 text-md sm:text-lg md:text-xl text-left flex flex-col justify-center items-start max-w-[1000px]">
                  <p>Le pilotage financier est devenu un fardeau  <span className="font-bold">complexe</span> et <span className="font-bold">pénible</span> pour les entrepreneurs.</p>
                  <p>Pourtant, il ne devrait pas limiter votre croissance mais en être un <span className="font-bold">levier</span>.</p>
                  <p>heelio offre une nouvelle voie en combinant le meilleur de la <span className="font-bold">technologie</span> et de <span className="font-bold">l’expertise humaine</span>.</p>
                  <p className="mt-10">Notre <span className="font-bold">plateforme</span> automatise votre reporting et vos analyses, et nos <span className="font-bold">directeurs financiers</span> vous accompagnent dans toutes vos décisions stratégiques.</p>
                  <p>Avec heelio, <span className="font-bold">maîtrisez vos finances</span> et concentrez-vous sur votre croissance <span className="font-bold">en toute sécurité</span>.</p>
                  <p className="mt-10">Nous sommes plus qu’un cabinet de DAF externalisé.</p>
                  <p>Nous sommes plus qu’un logiciel de planification et d’analyse financière.</p>
                  <p>Nous sommes&nbsp;&nbsp; 
                  <span className="relative inline-block">
                    <span className="bg-[#FED90F] w-[60px] sm:w-[72px] h-6 sm:h-8 absolute -top-.8 -left-1.5 z-1 rounded-lg transform rotate-[-2deg]"></span>
                    <span className="relative font-bold ">heelio</span>
                  </span>
                </p>
                  <p className="font-bold mt-10">Prenez le contrôle de votre succès</p>
                </div> 
              
              </div>

    </div>
        </div>
    )
}

export default ManifestText;